import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { PaymentAmount } from 'shell/models/payment-amount';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

type PaymentType =
  | 'stampDuty'
  | 'administrativeFees'
  | 'civilState'
  | 'fixedRights'
  | 'expenseAccount';

type PaymentMap = { [type in PaymentType]: string };

const codes: PaymentMap = {
  stampDuty: 'BL',
  administrativeFees: 'DS',
  civilState: 'DC',
  fixedRights: 'DF',
  expenseAccount: 'SP',
};

interface PaymentAmountProps {
  disabled?: boolean;
  value: string;
  onChange: (item: ItemVM | undefined) => void;
  error?: boolean;
  type?: PaymentType;
  placeholder?: string;
  id?: string;
  name?: string;
  label?: string;
}

const PaymentAmountListComponent = ({
  disabled,
  onChange,
  value,
  error,
  type,
  id,
  name,
  placeholder,
  label,
}: PaymentAmountProps): React.ReactElement => {
  const queryParams = type ? `?filters=codiceImportoPagamento:${codes[type]}:LIKE` : '';
  const [paymentsTypes] = useHttpFetch<HttpResponseList<PaymentAmount>, Array<ItemVM>>(
    `${__CERTIFICATION_API_URL__}/certificazione/importo-pagamento${queryParams}`,
    {
      onBootstrap: true,
      initialData: [],
      options: {
        method: 'GET',
        errorCatching: true,
        loading: true,
      },
      transformer: (response) => {
        return (response.data?.payload?.list || []).map((item) => ({
          id: item.key.codiceImportoPagamento,
          value: item.importoPagamento.toString(),
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={name}
        value={value}
        label={placeholder}
        onChange={(event) => {
          const item = (paymentsTypes.data as Array<ItemVM>)?.find(
            (payment) => payment.id === event.target.value
          );
          onChange(item);
        }}
        disabled={disabled}
        error={error}
      >
        {(paymentsTypes.data as Array<ItemVM>)?.map((payment: ItemVM) => (
          <MenuItem key={`${payment.id}-payment`} value={payment.id}>
            {payment.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

PaymentAmountListComponent.displayName = 'List register type component';

const PaymentAmountList = memo(PaymentAmountListComponent);

export default PaymentAmountList as typeof PaymentAmountListComponent;
